"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KB_ARTICLE_BLOCK_REGISTRY = exports.KB_ARTICLE_CANONICAL_BLOCK_TYPES = exports.KbArticleBlockDocumentSchema = exports.KbArticleBlockSchema = exports.KbArticleEmbedVideoBlockSchema = exports.KbArticleCodeBlockSchema = exports.KbArticleRelatedArticlesBlockSchema = exports.KbArticleTableBlockSchema = exports.KbArticleCtaBlockSchema = exports.KbArticleCardsBlockSchema = exports.KbArticleQuoteBlockSchema = exports.KbArticleStepsBlockSchema = exports.KbArticleImageTextBlockSchema = exports.KbArticleImageBlockSchema = exports.KbArticleCalloutBlockSchema = exports.KbArticleParagraphBlockSchema = exports.KbArticleHeadingBlockSchema = exports.KbArticleProseBlockSchema = exports.KbArticleHeroBlockSchema = exports.KB_ARTICLE_BLOCK_DOCUMENT_VERSION = void 0;
exports.createKbArticleBlockDocument = createKbArticleBlockDocument;
exports.serializeKbArticleBlocks = serializeKbArticleBlocks;
exports.parseKbArticleBlockDocument = parseKbArticleBlockDocument;
exports.safeParseKbArticleBlockDocument = safeParseKbArticleBlockDocument;
exports.isKbArticleBlockEnabled = isKbArticleBlockEnabled;
exports.createKbArticleBlock = createKbArticleBlock;
exports.resolveKbArticleDocumentFromBlockRows = resolveKbArticleDocumentFromBlockRows;
exports.deriveKbArticleTableOfContents = deriveKbArticleTableOfContents;
exports.validateKbArticleBlockDocument = validateKbArticleBlockDocument;
exports.parsePublishableKbArticleBlockDocument = parsePublishableKbArticleBlockDocument;
exports.extractKbArticlePlainText = extractKbArticlePlainText;
const zod_1 = require("zod");
const external_video_1 = require("./external-video");
exports.KB_ARTICLE_BLOCK_DOCUMENT_VERSION = 1;
const KbArticleBlockBaseSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    enabled: zod_1.z.boolean().optional(),
})
    .strict();
const HeadingLevelSchema = zod_1.z.enum(['h2', 'h3', 'h4']);
const ImageCropModeSchema = zod_1.z.enum(['cover', 'contain']).default('cover');
const ImageDisplayWidthSchema = zod_1.z
    .enum(['inline', 'wide', 'full'])
    .default('wide');
const ImagePresentationSchema = {
    focalX: zod_1.z.number().min(0).max(100).default(50),
    focalY: zod_1.z.number().min(0).max(100).default(50),
    cropMode: ImageCropModeSchema,
    displayWidth: ImageDisplayWidthSchema,
};
exports.KbArticleHeroBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('hero'),
    eyebrow: zod_1.z.string().nullable().optional(),
    heading: zod_1.z.string(),
    bodyMarkdown: zod_1.z.string().nullable().optional(),
    image: zod_1.z.unknown().nullable().optional(),
    alt: zod_1.z.string().nullable().optional(),
    ...ImagePresentationSchema,
    ctaLabel: zod_1.z.string().nullable().optional(),
    ctaHref: zod_1.z.string().nullable().optional(),
}).strict();
exports.KbArticleProseBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('prose'),
    heading: zod_1.z.string().nullable().optional(),
    headingLevel: HeadingLevelSchema.default('h2'),
    bodyMarkdown: zod_1.z.string(),
}).strict();
exports.KbArticleHeadingBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('heading'),
    level: HeadingLevelSchema.default('h2'),
    text: zod_1.z.string(),
}).strict();
exports.KbArticleParagraphBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('paragraph'),
    text: zod_1.z.string(),
}).strict();
exports.KbArticleCalloutBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('callout'),
    tone: zod_1.z.enum(['info', 'success', 'warning']).default('info'),
    title: zod_1.z.string().nullable().optional(),
    text: zod_1.z.string(),
}).strict();
exports.KbArticleImageBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('image'),
    image: zod_1.z.unknown().nullable().optional(),
    alt: zod_1.z.string(),
    caption: zod_1.z.string().nullable().optional(),
    ...ImagePresentationSchema,
}).strict();
exports.KbArticleImageTextBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('imageText'),
    heading: zod_1.z.string().nullable().optional(),
    headingLevel: HeadingLevelSchema.default('h2'),
    bodyMarkdown: zod_1.z.string(),
    image: zod_1.z.unknown().nullable().optional(),
    alt: zod_1.z.string(),
    caption: zod_1.z.string().nullable().optional(),
    imagePosition: zod_1.z.enum(['left', 'right']).default('left'),
    ...ImagePresentationSchema,
}).strict();
exports.KbArticleStepsBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('steps'),
    title: zod_1.z.string().nullable().optional(),
    items: zod_1.z.array(zod_1.z.string()).min(1),
}).strict();
exports.KbArticleQuoteBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('quote'),
    text: zod_1.z.string(),
    cite: zod_1.z.string().nullable().optional(),
}).strict();
exports.KbArticleCardsBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('cards'),
    title: zod_1.z.string().nullable().optional(),
    items: zod_1.z
        .array(zod_1.z
        .object({
        title: zod_1.z.string(),
        text: zod_1.z.string(),
        href: zod_1.z.string().nullable().optional(),
    })
        .strict())
        .min(1),
}).strict();
exports.KbArticleCtaBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('cta'),
    title: zod_1.z.string().nullable().optional(),
    text: zod_1.z.string().nullable().optional(),
    label: zod_1.z.string(),
    href: zod_1.z.string(),
}).strict();
exports.KbArticleTableBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('table'),
    heading: zod_1.z.string().nullable().optional(),
    columns: zod_1.z.array(zod_1.z.string()).min(1),
    rows: zod_1.z.array(zod_1.z.array(zod_1.z.string())).min(1),
}).strict();
exports.KbArticleRelatedArticlesBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('relatedArticles'),
    heading: zod_1.z.string().nullable().optional(),
    articleRowIds: zod_1.z.array(zod_1.z.string()).default([]),
}).strict();
exports.KbArticleCodeBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('code'),
    language: zod_1.z.string().nullable().optional(),
    code: zod_1.z.string(),
}).strict();
exports.KbArticleEmbedVideoBlockSchema = KbArticleBlockBaseSchema.extend({
    type: zod_1.z.literal('embed_video'),
    title: zod_1.z.string().min(1).max(160),
    poster: zod_1.z.unknown().nullable().optional(),
    posterAlt: zod_1.z.string().max(280).nullable().optional(),
    consentRequired: zod_1.z.boolean().default(true),
}).merge(external_video_1.ExternalVideoMetadataSchema);
exports.KbArticleBlockSchema = zod_1.z.discriminatedUnion('type', [
    exports.KbArticleHeroBlockSchema,
    exports.KbArticleProseBlockSchema,
    exports.KbArticleHeadingBlockSchema,
    exports.KbArticleParagraphBlockSchema,
    exports.KbArticleCalloutBlockSchema,
    exports.KbArticleImageBlockSchema,
    exports.KbArticleImageTextBlockSchema,
    exports.KbArticleStepsBlockSchema,
    exports.KbArticleQuoteBlockSchema,
    exports.KbArticleCardsBlockSchema,
    exports.KbArticleCtaBlockSchema,
    exports.KbArticleTableBlockSchema,
    exports.KbArticleRelatedArticlesBlockSchema,
    exports.KbArticleCodeBlockSchema,
    exports.KbArticleEmbedVideoBlockSchema,
]);
exports.KbArticleBlockDocumentSchema = zod_1.z
    .object({
    version: zod_1.z.literal(exports.KB_ARTICLE_BLOCK_DOCUMENT_VERSION),
    blocks: zod_1.z.array(exports.KbArticleBlockSchema),
})
    .strict();
exports.KB_ARTICLE_CANONICAL_BLOCK_TYPES = [
    'hero',
    'prose',
    'image',
    'imageText',
    'callout',
    'quote',
    'code',
    'steps',
    'table',
    'cta',
    'relatedArticles',
    'embed_video',
];
function registryEntry(input) {
    return {
        ...input,
        canonical: input.canonical ?? true,
    };
}
exports.KB_ARTICLE_BLOCK_REGISTRY = {
    hero: registryEntry({
        type: 'hero',
        label: 'Hero',
        description: 'Opening visual section with heading, summary and CTA.',
        schema: exports.KbArticleHeroBlockSchema,
        editorFields: [
            'eyebrow',
            'heading',
            'bodyMarkdown',
            'image',
            'alt',
            'focalX',
            'focalY',
            'cropMode',
            'displayWidth',
        ],
        seoTextFields: ['eyebrow', 'heading', 'bodyMarkdown', 'alt'],
        mcpDescription: 'Use for the first article section. H1 remains the article title; hero heading renders below it.',
    }),
    prose: registryEntry({
        type: 'prose',
        label: 'Prose',
        description: 'Markdown paragraph section with optional heading.',
        schema: exports.KbArticleProseBlockSchema,
        editorFields: ['heading', 'headingLevel', 'bodyMarkdown'],
        seoTextFields: ['heading', 'bodyMarkdown'],
        mcpDescription: 'Use for normal article text. Markdown is allowed.',
    }),
    heading: registryEntry({
        type: 'heading',
        label: 'Heading',
        description: 'Legacy standalone heading block.',
        schema: exports.KbArticleHeadingBlockSchema,
        editorFields: ['level', 'text'],
        seoTextFields: ['text'],
        mcpDescription: 'Legacy heading block; prefer prose.heading for new writes.',
        canonical: false,
    }),
    paragraph: registryEntry({
        type: 'paragraph',
        label: 'Paragraph',
        description: 'Legacy plain paragraph block.',
        schema: exports.KbArticleParagraphBlockSchema,
        editorFields: ['text'],
        seoTextFields: ['text'],
        mcpDescription: 'Legacy paragraph block; prefer prose.bodyMarkdown for new writes.',
        canonical: false,
    }),
    callout: registryEntry({
        type: 'callout',
        label: 'Callout',
        description: 'Highlighted note, warning or success message.',
        schema: exports.KbArticleCalloutBlockSchema,
        editorFields: ['tone', 'title', 'text'],
        seoTextFields: ['title', 'text'],
        mcpDescription: 'Use for important notes with tone info/success/warning.',
    }),
    image: registryEntry({
        type: 'image',
        label: 'Image',
        description: 'Attachment-first image with alt text and optional caption.',
        schema: exports.KbArticleImageBlockSchema,
        editorFields: [
            'image',
            'alt',
            'caption',
            'focalX',
            'focalY',
            'cropMode',
            'displayWidth',
        ],
        seoTextFields: ['alt', 'caption'],
        mcpDescription: 'Use attachment values from blob_upload or workspace assets; alt text is required.',
    }),
    imageText: registryEntry({
        type: 'imageText',
        label: 'Image + Text',
        description: 'Two-column image and prose section.',
        schema: exports.KbArticleImageTextBlockSchema,
        editorFields: [
            'heading',
            'headingLevel',
            'bodyMarkdown',
            'image',
            'alt',
            'caption',
            'imagePosition',
            'focalX',
            'focalY',
            'cropMode',
            'displayWidth',
        ],
        seoTextFields: ['heading', 'bodyMarkdown', 'alt', 'caption'],
        mcpDescription: 'Use for visual explanations with adjacent text.',
    }),
    steps: registryEntry({
        type: 'steps',
        label: 'Steps',
        description: 'Ordered checklist or process sequence.',
        schema: exports.KbArticleStepsBlockSchema,
        editorFields: ['title', 'items'],
        seoTextFields: ['title', 'items'],
        mcpDescription: 'Use for ordered procedures.',
    }),
    quote: registryEntry({
        type: 'quote',
        label: 'Quote',
        description: 'Pull quote with optional cite.',
        schema: exports.KbArticleQuoteBlockSchema,
        editorFields: ['text', 'cite'],
        seoTextFields: ['text', 'cite'],
        mcpDescription: 'Use sparingly for cited statements.',
    }),
    cards: registryEntry({
        type: 'cards',
        label: 'Cards',
        description: 'Legacy card grid block.',
        schema: exports.KbArticleCardsBlockSchema,
        editorFields: ['title', 'items'],
        seoTextFields: ['title', 'items'],
        mcpDescription: 'Legacy card block; prefer relatedArticles or prose links for new writes.',
        canonical: false,
    }),
    cta: registryEntry({
        type: 'cta',
        label: 'CTA',
        description: 'Call-to-action block with label and link.',
        schema: exports.KbArticleCtaBlockSchema,
        editorFields: ['title', 'text', 'label', 'href'],
        seoTextFields: ['title', 'text', 'label'],
        mcpDescription: 'Use for a single next action.',
    }),
    table: registryEntry({
        type: 'table',
        label: 'Table',
        description: 'Small structured comparison or reference table.',
        schema: exports.KbArticleTableBlockSchema,
        editorFields: ['heading', 'columns', 'rows'],
        seoTextFields: ['heading', 'columns', 'rows'],
        mcpDescription: 'Use for compact structured data; keep tables scannable.',
    }),
    relatedArticles: registryEntry({
        type: 'relatedArticles',
        label: 'Related Articles',
        description: 'Manual related-article picks by article row id.',
        schema: exports.KbArticleRelatedArticlesBlockSchema,
        editorFields: ['heading', 'articleRowIds'],
        seoTextFields: ['heading'],
        mcpDescription: 'Use articleRowIds to pin related articles; renderer can combine with automatic topic matches.',
    }),
    code: registryEntry({
        type: 'code',
        label: 'Code',
        description: 'Code sample with optional language.',
        schema: exports.KbArticleCodeBlockSchema,
        editorFields: ['language', 'code'],
        seoTextFields: ['code'],
        mcpDescription: 'Use for short code snippets; do not embed unsafe HTML.',
    }),
    embed_video: registryEntry({
        type: 'embed_video',
        label: 'External video',
        description: 'Consent-gated YouTube or Vimeo video metadata.',
        schema: exports.KbArticleEmbedVideoBlockSchema,
        editorFields: [
            'title',
            'provider',
            'videoId',
            'caption',
            'poster',
            'posterAlt',
            'consentRequired',
        ],
        seoTextFields: ['title', 'caption', 'posterAlt'],
        mcpDescription: 'Use provider + videoId only. Arbitrary iframe URLs are not accepted.',
    }),
};
function createKbArticleBlockDocument(blocks) {
    return exports.KbArticleBlockDocumentSchema.parse({
        version: exports.KB_ARTICLE_BLOCK_DOCUMENT_VERSION,
        blocks,
    });
}
function serializeKbArticleBlocks(blocks) {
    return JSON.stringify(createKbArticleBlockDocument(blocks), null, 2);
}
function parseKbArticleBlockDocument(value) {
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) {
            return createKbArticleBlockDocument([]);
        }
        return exports.KbArticleBlockDocumentSchema.parse(JSON.parse(trimmed));
    }
    return exports.KbArticleBlockDocumentSchema.parse(value);
}
function safeParseKbArticleBlockDocument(value) {
    try {
        return parseKbArticleBlockDocument(value);
    }
    catch {
        return null;
    }
}
function isKbArticleBlockEnabled(block) {
    return block.enabled !== false;
}
function createKbArticleBlock(type, index) {
    const id = `block-${Date.now().toString(36)}-${index}`;
    switch (type) {
        case 'hero':
            return {
                id,
                type,
                eyebrow: null,
                heading: 'Einleitung',
                bodyMarkdown: 'Fasse das Problem und den Nutzen dieses Artikels kurz zusammen.',
                image: null,
                alt: null,
                focalX: 50,
                focalY: 50,
                cropMode: 'cover',
                displayWidth: 'wide',
                ctaLabel: null,
                ctaHref: null,
            };
        case 'prose':
            return {
                id,
                type,
                heading: 'Abschnitt',
                headingLevel: 'h2',
                bodyMarkdown: 'Neuer Abschnitt',
            };
        case 'heading':
            return { id, type, level: 'h2', text: 'Neue Ueberschrift' };
        case 'paragraph':
            return { id, type, text: 'Neuer Absatz' };
        case 'callout':
            return { id, type, tone: 'info', title: 'Hinweis', text: 'Details' };
        case 'image':
            return {
                id,
                type,
                image: null,
                alt: 'Bildbeschreibung',
                caption: null,
                focalX: 50,
                focalY: 50,
                cropMode: 'cover',
                displayWidth: 'wide',
            };
        case 'imageText':
            return {
                id,
                type,
                heading: 'Bild und Kontext',
                headingLevel: 'h2',
                bodyMarkdown: 'Erklaere, was im Bild zu sehen ist.',
                image: null,
                alt: 'Bildbeschreibung',
                caption: null,
                imagePosition: 'left',
                focalX: 50,
                focalY: 50,
                cropMode: 'cover',
                displayWidth: 'wide',
            };
        case 'steps':
            return { id, type, title: 'Schritte', items: ['Erster Schritt'] };
        case 'quote':
            return { id, type, text: 'Zitat', cite: null };
        case 'cards':
            return {
                id,
                type,
                title: 'Weiterfuehrende Inhalte',
                items: [{ title: 'Karte', text: 'Beschreibung', href: null }],
            };
        case 'cta':
            return {
                id,
                type,
                title: 'Naechster Schritt',
                text: 'Fuehre Leser gezielt weiter.',
                label: 'Weiter',
                href: '#',
            };
        case 'table':
            return {
                id,
                type,
                heading: 'Uebersicht',
                columns: ['Spalte A', 'Spalte B'],
                rows: [['Wert A', 'Wert B']],
            };
        case 'relatedArticles':
            return {
                id,
                type,
                heading: 'Weitere Artikel',
                articleRowIds: [],
            };
        case 'code':
            return { id, type, language: null, code: 'const example = true;' };
        case 'embed_video':
            return {
                id,
                type,
                title: 'Video',
                provider: 'youtube',
                videoId: 'dQw4w9WgXcQ',
                autoplay: false,
                caption: undefined,
                poster: null,
                posterAlt: null,
                consentRequired: true,
            };
    }
}
function resolveKbArticleDocumentFromBlockRows(input) {
    const rows = input.rows
        .filter(row => rowBelongsToArticleBlockDocument(row, input))
        .sort((left, right) => readRowOrder(left, input.columns) - readRowOrder(right, input.columns));
    const issues = [];
    const blocks = [];
    for (const row of rows) {
        const blockId = cleanRowString(readRowCell(row, input.columns, 'blockId')) ?? row.id;
        const type = cleanRowString(readRowCell(row, input.columns, 'type'));
        if (!type) {
            issues.push({
                rowId: row.id,
                blockId,
                field: 'type',
                message: 'Article block row needs a block type.',
            });
            continue;
        }
        if (!isKbArticleBlockType(type)) {
            issues.push({
                rowId: row.id,
                blockId,
                field: 'type',
                message: `Article block type "${type}" is not supported.`,
            });
            continue;
        }
        const props = parseBlockRowProps(readRowCell(row, input.columns, 'propsJson'));
        if (!props.success) {
            issues.push({
                rowId: row.id,
                blockId,
                field: 'propsJson',
                message: props.message,
            });
            continue;
        }
        const parsed = parseKbArticleBlockSourceRow(row, input.columns, blockId, type, props.data);
        if (!parsed.success) {
            const issue = parsed.error.issues[0];
            issues.push({
                rowId: row.id,
                blockId,
                field: issue?.path.join('.') || 'block',
                message: issue?.message ?? 'Article block row is invalid.',
            });
            continue;
        }
        blocks.push(parsed.data);
    }
    return {
        document: issues.length === 0 && blocks.length > 0
            ? createKbArticleBlockDocument(blocks)
            : null,
        issues,
        matchedRowCount: rows.length,
    };
}
function isKbArticleBlockType(value) {
    return Object.prototype.hasOwnProperty.call(exports.KB_ARTICLE_BLOCK_REGISTRY, value);
}
function rowBelongsToArticleBlockDocument(row, input) {
    const enabled = readRowCell(row, input.columns, 'enabled');
    if (enabled === false || enabled === 'false')
        return false;
    const relation = readRowCell(row, input.columns, 'article');
    if (relationMatchesArticle(relation, input.articleRowId))
        return true;
    const articleId = readRowCell(row, input.columns, 'articleId');
    return (articleId === input.articleRowId ||
        (!!input.articleSlug && articleId === input.articleSlug));
}
function relationMatchesArticle(value, articleRowId) {
    if (Array.isArray(value)) {
        return value.some(item => relationMatchesArticle(item, articleRowId));
    }
    if (typeof value === 'object' && value !== null) {
        const record = value;
        return relationMatchesArticle(record['id'] ?? record['rowId'] ?? record['value'], articleRowId);
    }
    if (typeof value !== 'string')
        return false;
    return value
        .split(',')
        .map(item => item.trim())
        .includes(articleRowId);
}
function readRowOrder(row, columns) {
    const order = readRowCell(row, columns, 'order');
    const parsed = Number(order);
    return Number.isFinite(parsed) ? parsed : 0;
}
function parseBlockRowProps(value) {
    if (value == null || value === '')
        return { success: true, data: {} };
    if (typeof value === 'object' && !Array.isArray(value)) {
        return { success: true, data: value };
    }
    if (typeof value !== 'string') {
        return {
            success: false,
            message: 'propsJson must be a JSON object.',
        };
    }
    try {
        const parsed = JSON.parse(value);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            return { success: true, data: parsed };
        }
        return {
            success: false,
            message: 'propsJson must be a JSON object.',
        };
    }
    catch {
        return {
            success: false,
            message: 'propsJson contains invalid JSON.',
        };
    }
}
function parseKbArticleBlockSourceRow(row, columns, blockId, type, props) {
    const base = { id: blockId, type };
    const heading = readRowString(row, columns, ['heading']) ??
        readPropString(props, 'heading');
    const bodyMarkdown = readRowString(row, columns, ['bodyMarkdown']) ??
        readPropString(props, 'bodyMarkdown');
    const image = readFirstRowCell(row, columns, ['image']) ?? props['image'];
    const alt = readRowString(row, columns, ['imageAlt', 'alt']) ??
        readPropString(props, 'imageAlt') ??
        readPropString(props, 'alt') ??
        '';
    const caption = readRowString(row, columns, ['caption']) ??
        readPropString(props, 'caption');
    const imagePresentation = {
        focalX: readRowNumber(row, columns, ['focalX']) ??
            readPropNumber(props, 'focalX') ??
            50,
        focalY: readRowNumber(row, columns, ['focalY']) ??
            readPropNumber(props, 'focalY') ??
            50,
        cropMode: readRowString(row, columns, ['cropMode']) ??
            readPropString(props, 'cropMode') ??
            'cover',
        displayWidth: readRowString(row, columns, ['displayWidth']) ??
            readPropString(props, 'displayWidth') ??
            'wide',
    };
    switch (type) {
        case 'hero':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                eyebrow: readPropString(props, 'eyebrow'),
                heading: heading ?? '',
                bodyMarkdown,
                image,
                alt,
                ...imagePresentation,
                ctaLabel: readPropString(props, 'ctaLabel'),
                ctaHref: readPropString(props, 'ctaHref'),
            });
        case 'prose':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                heading,
                headingLevel: readRowString(row, columns, ['headingLevel']) ??
                    readPropString(props, 'headingLevel') ??
                    'h2',
                bodyMarkdown: bodyMarkdown ?? '',
            });
        case 'image':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                image,
                alt,
                caption,
                ...imagePresentation,
            });
        case 'imageText':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                heading,
                headingLevel: readRowString(row, columns, ['headingLevel']) ??
                    readPropString(props, 'headingLevel') ??
                    'h2',
                bodyMarkdown: bodyMarkdown ?? '',
                image,
                alt,
                caption,
                imagePosition: readPropString(props, 'imagePosition') ?? 'left',
                ...imagePresentation,
            });
        case 'callout':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                tone: readPropString(props, 'tone') ?? 'info',
                title: heading ?? readPropString(props, 'title'),
                text: bodyMarkdown ?? readPropString(props, 'text') ?? '',
            });
        case 'quote':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                text: bodyMarkdown ?? readPropString(props, 'text') ?? '',
                cite: readPropString(props, 'cite'),
            });
        case 'code':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                language: readPropString(props, 'language'),
                code: bodyMarkdown ?? readPropString(props, 'code') ?? '',
            });
        case 'embed_video':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                title: heading ?? readPropString(props, 'title') ?? '',
                provider: readPropString(props, 'provider') ?? 'youtube',
                videoId: readPropString(props, 'videoId') ?? '',
                autoplay: readPropBoolean(props, 'autoplay') ?? false,
                caption: readPropString(props, 'caption'),
                poster: props['poster'] ?? null,
                posterAlt: readPropString(props, 'posterAlt'),
                consentRequired: readPropBoolean(props, 'consentRequired') ?? true,
            });
        case 'steps':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                title: heading ?? readPropString(props, 'title'),
                items: readStringArray(props['items']) ?? markdownLines(bodyMarkdown ?? ''),
            });
        case 'table':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                heading,
                columns: readStringArray(props['columns']) ?? ['Spalte'],
                rows: readTableRows(props['rows']) ?? [
                    markdownLines(bodyMarkdown ?? ''),
                ],
            });
        case 'cta':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                title: heading ?? readPropString(props, 'title'),
                text: bodyMarkdown ?? readPropString(props, 'text'),
                label: readPropString(props, 'label') ?? 'Weiter',
                href: readPropString(props, 'href') ?? '#',
            });
        case 'relatedArticles':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                heading,
                articleRowIds: readStringArray(props['articleRowIds']) ?? [],
            });
        case 'heading':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                level: readRowString(row, columns, ['headingLevel']) ??
                    readPropString(props, 'level') ??
                    'h2',
                text: heading ?? bodyMarkdown ?? readPropString(props, 'text') ?? '',
            });
        case 'paragraph':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                text: bodyMarkdown ?? readPropString(props, 'text') ?? '',
            });
        case 'cards':
            return exports.KbArticleBlockSchema.safeParse({
                ...base,
                title: heading ?? readPropString(props, 'title'),
                items: readCardItems(props['items']) ?? [
                    { title: 'Karte', text: bodyMarkdown ?? 'Beschreibung', href: null },
                ],
            });
    }
}
function readFirstRowCell(row, columns, names) {
    for (const name of names) {
        const value = readRowCell(row, columns, name);
        if (value !== undefined && value !== null && value !== '')
            return value;
    }
    return null;
}
function readRowString(row, columns, names) {
    for (const name of names) {
        const value = cleanRowString(readRowCell(row, columns, name));
        if (value)
            return value;
    }
    return null;
}
function readRowNumber(row, columns, names) {
    for (const name of names) {
        const value = readRowCell(row, columns, name);
        const parsed = typeof value === 'string' ? Number(value) : value;
        if (typeof parsed === 'number' && Number.isFinite(parsed))
            return parsed;
    }
    return null;
}
function readPropString(props, key) {
    return cleanRowString(props[key]);
}
function readPropBoolean(props, key) {
    const value = props[key];
    return typeof value === 'boolean' ? value : null;
}
function readPropNumber(props, key) {
    const value = props[key];
    const parsed = typeof value === 'string' ? Number(value) : value;
    return typeof parsed === 'number' && Number.isFinite(parsed) ? parsed : null;
}
function readStringArray(value) {
    if (!Array.isArray(value))
        return null;
    const items = value.filter((item) => typeof item === 'string' && item.trim() !== '');
    return items.length > 0 ? items : null;
}
function readTableRows(value) {
    if (!Array.isArray(value))
        return null;
    const rows = value
        .filter((row) => Array.isArray(row))
        .map(row => row
        .filter((cell) => typeof cell === 'string' && cell.trim() !== '')
        .map(cell => cell.trim()))
        .filter(row => row.length > 0);
    return rows.length > 0 ? rows : null;
}
function readCardItems(value) {
    if (!Array.isArray(value))
        return null;
    const items = value
        .filter((item) => Boolean(item) && typeof item === 'object')
        .map(item => {
        const title = cleanRowString(item.title);
        const text = cleanRowString(item.text);
        if (!title || !text)
            return null;
        return { title, text, href: cleanRowString(item.href) };
    })
        .filter((item) => item !== null);
    return items.length > 0 ? items : null;
}
function markdownLines(value) {
    return value
        .split(/\n+/)
        .map(line => line.replace(/^[-*\d.]+\s*/, '').trim())
        .filter(Boolean);
}
function readRowCell(row, columns, columnName) {
    const cells = row.cells;
    if (cells) {
        const column = columns?.find(item => item.name === columnName);
        const byColumnId = column ? cells[column.id] : undefined;
        if (byColumnId !== undefined)
            return byColumnId;
        if (cells[columnName] !== undefined)
            return cells[columnName];
    }
    return row[columnName];
}
function cleanRowString(value) {
    if (typeof value !== 'string')
        return null;
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
}
function deriveKbArticleTableOfContents(document) {
    return document.blocks.filter(isKbArticleBlockEnabled).flatMap(block => {
        if (block.type === 'heading' && block.text.trim() !== '') {
            return [
                {
                    id: block.id,
                    text: block.text.trim(),
                    level: Number(block.level.slice(1)),
                },
            ];
        }
        if ((block.type === 'prose' || block.type === 'imageText') &&
            block.heading?.trim()) {
            return [
                {
                    id: block.id,
                    text: block.heading.trim(),
                    level: Number(block.headingLevel?.slice(1) ?? '2'),
                },
            ];
        }
        if (block.type === 'hero' && block.heading.trim() !== '') {
            return [{ id: block.id, text: block.heading.trim(), level: 2 }];
        }
        if ((block.type === 'table' || block.type === 'relatedArticles') &&
            block.heading?.trim()) {
            return [{ id: block.id, text: block.heading.trim(), level: 2 }];
        }
        return [];
    });
}
function validateKbArticleBlockDocument(document) {
    const issues = [];
    for (const block of document.blocks.filter(isKbArticleBlockEnabled)) {
        switch (block.type) {
            case 'hero':
                requireText(issues, block.id, 'heading', block.heading);
                break;
            case 'prose':
                requireText(issues, block.id, 'bodyMarkdown', block.bodyMarkdown);
                break;
            case 'heading':
            case 'paragraph':
            case 'quote':
                requireText(issues, block.id, 'text', block.text);
                break;
            case 'callout':
                requireText(issues, block.id, 'text', block.text);
                break;
            case 'image':
                requireText(issues, block.id, 'alt', block.alt);
                if (block.image == null || block.image === '') {
                    issues.push({
                        blockId: block.id,
                        field: 'image',
                        message: 'Image block needs an attachment or image value.',
                    });
                }
                break;
            case 'imageText':
                requireText(issues, block.id, 'bodyMarkdown', block.bodyMarkdown);
                requireText(issues, block.id, 'alt', block.alt);
                if (block.image == null || block.image === '') {
                    issues.push({
                        blockId: block.id,
                        field: 'image',
                        message: 'ImageText block needs an attachment or image value.',
                    });
                }
                break;
            case 'steps':
                if (block.items.length === 0) {
                    issues.push({
                        blockId: block.id,
                        field: 'items',
                        message: 'Steps block needs at least one step.',
                    });
                }
                block.items.forEach((item, index) => requireText(issues, block.id, `items.${index}`, item));
                break;
            case 'cards':
                if (block.items.length === 0) {
                    issues.push({
                        blockId: block.id,
                        field: 'items',
                        message: 'Cards block needs at least one card.',
                    });
                }
                block.items.forEach((item, index) => {
                    requireText(issues, block.id, `items.${index}.title`, item.title);
                    requireText(issues, block.id, `items.${index}.text`, item.text);
                });
                break;
            case 'cta':
                requireText(issues, block.id, 'label', block.label);
                requireText(issues, block.id, 'href', block.href);
                break;
            case 'table':
                block.columns.forEach((column, index) => requireText(issues, block.id, `columns.${index}`, column));
                block.rows.forEach((row, rowIndex) => row.forEach((cell, columnIndex) => requireText(issues, block.id, `rows.${rowIndex}.${columnIndex}`, cell)));
                break;
            case 'relatedArticles':
                break;
            case 'code':
                requireText(issues, block.id, 'code', block.code);
                break;
            case 'embed_video':
                requireText(issues, block.id, 'title', block.title);
                if (!(0, external_video_1.isExternalVideoIdValid)(block)) {
                    issues.push({
                        blockId: block.id,
                        field: 'videoId',
                        message: `Invalid ${block.provider} video id.`,
                    });
                }
                break;
        }
    }
    return issues;
}
function parsePublishableKbArticleBlockDocument(value) {
    const document = parseKbArticleBlockDocument(value);
    const issues = validateKbArticleBlockDocument(document);
    if (issues.length > 0) {
        throw new Error(issues
            .map(issue => `${issue.blockId}.${issue.field}: ${issue.message}`)
            .join('; '));
    }
    return document;
}
function requireText(issues, blockId, field, value) {
    if (typeof value === 'string' && value.trim() !== '')
        return;
    issues.push({
        blockId,
        field,
        message: `${field} must not be empty.`,
    });
}
function extractKbArticlePlainText(document) {
    return document.blocks
        .filter(isKbArticleBlockEnabled)
        .flatMap(block => {
        switch (block.type) {
            case 'hero':
                return [block.eyebrow, block.heading, block.bodyMarkdown, block.alt];
            case 'prose':
                return [block.heading, block.bodyMarkdown];
            case 'heading':
            case 'paragraph':
            case 'quote':
                return [block.text];
            case 'callout':
                return [block.title, block.text];
            case 'image':
                return [block.alt, block.caption];
            case 'imageText':
                return [block.heading, block.bodyMarkdown, block.alt, block.caption];
            case 'steps':
                return [block.title, ...block.items];
            case 'cards':
                return [
                    block.title,
                    ...block.items.flatMap(item => [item.title, item.text]),
                ];
            case 'cta':
                return [block.title, block.text, block.label];
            case 'table':
                return [block.heading, ...block.columns, ...block.rows.flat()];
            case 'relatedArticles':
                return [block.heading];
            case 'code':
                return [block.code];
            case 'embed_video':
                return [block.title, block.caption, block.posterAlt];
        }
    })
        .filter((value) => Boolean(value?.trim()))
        .join('\n');
}
